<template>
    <div class="card card-body">
        <div class="row">
            <div class="col-md-12">
                <!-- Status Banner -->
                <div class="alert" :class="{'alert-success': job.complete, 'alert-warning': !job.complete}">
                    <animated-success v-if="job.complete"></animated-success>
                    <icon-tools v-if="!job.complete"></icon-tools>
                    <div class="alert-content">
                        Job Status: <strong v-if="job.complete">Completed</strong><strong v-if="!job.complete">Pending</strong>
                    </div>
                    <button class="btn btn-light btn-sm" v-b-modal.waiver-signature-modal v-if="!job.complete && showJobCompleteButton">Mark complete</button>
                </div>
            </div>
            <div class="col-sm-8 col-lg-9">
                <div class="row">
                    <dl class="col-6">
                        <dt>Order ID</dt>
                        <dd>
                            <template v-if="job.order_id">{{ job.order_id }}</template>
                            <template v-if="!job.order_id">--</template>
                        </dd>
                    </dl>
                    <dl class="col-6">
                        <dt>Job type</dt>
                        <dd class="text-capitalize">
                            <template v-if="job.job_type">{{ job.job_type }}</template>
                            <template v-if="!job.job_type">--</template>
                        </dd>
                    </dl>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3">
                <a class="btn btn-info btn-block mb-3" v-if="job.order_id" :href="`https://wefix.co.uk/company/orders/${job.order_id}`" target="_blank">View in admin</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {

        props:['jobId', 'showJobCompleteButton'],

        data() {
            return {
                loading: true,
            };
        },

        computed: {
            ...mapGetters([
                "devices",
                "job",
                "isSuperAdmin",
                "isTechnician",
                "jobNotes",
                "user"
            ]),
        },

        methods: {
            ...mapActions([
                "loadJob"
            ])
        }
    }
</script>

<style scoped>

</style>